var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGithub = function SvgGithub(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.065 0C8.23 0 0 7.163 0 16c0 7.07 4.584 13.066 10.942 15.182.8.147 1.092-.347 1.092-.77 0-.38-.013-1.387-.02-2.722-4.452.966-5.39-2.145-5.39-2.145-.73-1.85-1.778-2.34-1.778-2.34-1.452-.993.11-.973.11-.973 1.606.113 2.45 1.65 2.45 1.65 1.428 2.444 3.746 1.737 4.658 1.328.145-1.033.56-1.74 1.015-2.138-3.556-.404-7.29-1.777-7.29-7.908 0-1.747.622-3.176 1.645-4.294-.165-.404-.714-2.032.158-4.234 0 0 1.342-.43 4.4 1.64 1.275-.355 2.644-.532 4.004-.54 1.36.008 2.727.185 4.005.54 3.055-2.07 4.395-1.64 4.395-1.64.875 2.202.326 3.83.162 4.234 1.024 1.118 1.643 2.547 1.643 4.294 0 6.146-3.74 7.5-7.305 7.895.575.49 1.086 1.47 1.086 2.96 0 2.14-.02 3.863-.02 4.39 0 .426.29.924 1.1.77C27.42 29.06 32 23.066 32 16c0-8.837-7.164-16-16-16",
    fill: "#000"
  }))));
};
export default SvgGithub;